import { ClientOnly } from "@tanstack/react-router";

import { MarketingFooter } from "@/web/routes/-marketing/MarketingFooter";
import { MarketingNavbar } from "@/web/routes/-marketing/MarketingNavbar";

/**
 * Shared shell for the static legal pages (privacy, terms). Wraps prose-styled
 * HTML — compiled from a markdown file at build time (see `markdownHtml` in
 * vite.config.ts) — in the solid marketing navbar (logo → home, About Us link)
 * and footer. `html` is trusted, repo-owned content, so dangerouslySetInnerHTML
 * is safe here. Brand colors are applied via the typography plugin's CSS vars.
 */
export function LegalPage({
  title,
  html,
  contentClassName,
}: {
  title: string;
  html: string;
  contentClassName?: string;
}) {
  return (
    <div className="flex w-full flex-col overflow-x-clip">
      {/* Navbar depends on Clerk + scroll position — client-only to avoid SSR hangs. */}
      <ClientOnly>
        <MarketingNavbar solid />
      </ClientOnly>

      <main className="flex w-full flex-col">
        <article className="mx-auto prose w-full max-w-3xl px-6 pt-28 pb-24 [--tw-prose-body:var(--withus-dark-blue)] [--tw-prose-bold:var(--withus-dark-blue)] [--tw-prose-bullets:var(--withus-blue)] [--tw-prose-counters:var(--withus-dark-blue)] [--tw-prose-headings:var(--withus-dark-blue)] [--tw-prose-links:var(--withus-blue)] md:px-10 prose-headings:font-semibold">
          <h1 className="font-heading text-withus-dark-blue">{title}</h1>
          <div className={contentClassName} dangerouslySetInnerHTML={{ __html: html }} />
        </article>
      </main>

      <MarketingFooter />
    </div>
  );
}
